"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var GoogleMapsClusterRenderer = /** @class */ (function () {
    function GoogleMapsClusterRenderer() {
    }
    GoogleMapsClusterRenderer.prototype.render = function (_a, stats, map) {
        //https://googlemaps.github.io/js-markerclusterer/
        var position = _a.position;
        var locationPinPlus = document.createElement('div');
        locationPinPlus.className = 'location-pin--cluster';
        var zIndex = 999;
        var title = '';
        var clusterOptions = {
            map: map,
            position: position,
            zIndex: zIndex,
            title: title,
            content: locationPinPlus,
        };
        return new google.maps.marker.AdvancedMarkerElement(clusterOptions);
    };
    return GoogleMapsClusterRenderer;
}());
exports.default = GoogleMapsClusterRenderer;
